
import { defineComponent } from 'vue'
import { mapState, useStore, mapGetters } from 'vuex'
import GradientButton from '@remote/components/GradientButton.vue'
import { msToTime, formatTime } from '@remote/utils'
import { getLocalValue } from '@remote/utils/index'
import { useDisk } from '@remote/store/hezi-file/disk'
import copy from 'clipboard-copy'
import '@remote/assets/css/fail.scss'

export default defineComponent({
  name: 'Fail',
  components: { GradientButton },
  setup () {
    const store = useStore()
    const diskStore = useDisk()
    return {
      store,
      diskStore,
    }
  },
  data () {
    return {
      clickCount: 0,
      showFailBtn: false,
      connectMessage: '',
      showFailDialog: false,
    }
  },
  computed: {
    ...mapState(['status', 'connecting', 'checking', 'runners', 'all', 'curDeviceRunner']),
    ...mapGetters(['deviceTime']),
    list (): any[] {
      const devices = this.runners.map(id => this.all[id])
      return devices
    },
    tip (): string {
      if (this.isDiskException) return '当前设备未发现磁盘'
      return this.connecting  ? '检查设备中' : this.curDeviceRunner?.id ? '设备离线' :'未找到可远程下载的设备'
    },
    tipBtn (): string {
      return this.connecting ? '正在连接中' : '重新连接'
    },
    lastTime (): string {
      const id = this.curDeviceRunner?.id
      const deviceTime = id ? formatTime(this.deviceTime, 'MM-dd hh:mm') : ''
      return id ? `4、当前设备最近活跃时间为: ${deviceTime} (${msToTime(this.curDeviceRunner.since/1000)}前)` : ''
    },
    isDiskException () {
      return this.status === 1 && this.diskStore?.data?.diskException
    },
  },
  methods: {
    copyClose () {
      copy(this.connectMessage)
      this.showFailDialog = false
    },
    handleRetry () {
      this.clickCount++
      if (this.clickCount >= 5) {
        location.reload() // 如果用户点了5下，就给他reload一下页面。
      }
      this.diskStore.checkDeviceDisk()
      if (this.connecting) return
      this.store.dispatch('login')
      this.connectMessage = getLocalValue('connectMessage') && JSON.stringify(getLocalValue('connectMessage'))
      this.showFailBtn = !!this.connectMessage
    },
  },
})
